<template>
  <div class="">
    <div>
      <div
        class="pending-search d-flex justify-content-between align-item-center flex-wrap gap-3"
      >
        <form class="search-bar" @submit.prevent="searchData">
          <input
            type="text"
            class="pendingSearch-field"
            v-model="search"
            placeholder="Search by name, email, phone, code"
          />
          <select
            v-if="pendingGroupRenewals"
            class="renewal-select form-select w-auto"
            v-model="renewalDays"          >
            <option value="" disabled selected>Select Renewals Days</option>
            <option value="30">Wthin 30 Days</option>
            <option value="60">Within 30 to 60 Days</option>
            <option value="90"> Within 60 to 90 Days</option>
          </select>

            <select
            v-if="pendingGroupRenewals"
            class="renewal-select form-select w-auto"
            v-model="groupStatus"
            >
            <option value="" disabled selected>Select Status</option>
            <option value="active">ACTIVE</option>
            <option value="inactive">INACTIVE</option>
            <option value="terminated">TERMED</option>
          </select>
          
          <button type="submit" class="searchBtn">
            Search
          </button>
          <button type="reset" class="clearBtn" @click="clearData">
            Clear
          </button>
        </form>
        <button
          v-if="isL713 || pendingGroupRenewals"
          type="button"
          class="univ-btn my-0"
          @click.prevent="handleExport"
        >
          Export
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PendingSearch",
  data: () => ({
    search: "",
    renewalDays: "",
    groupStatus:"",
  }),
  props: {
    isL713: {
      default: false,
      type: Boolean,
      required: false,
    },
    pendingGroupRenewals: {
      default: false,
      type: Boolean,
      required: false,
    },
  },
  methods: {
    clearData() {
      this.search = "";
      this.renewalDays = "";
      this.groupStatus="";
      this.$emit("onClear");
    },
    searchData() {
      this.$emit("onSearch", this.search,this.groupStatus,this.renewalDays);
    },
    handleExport() {
      this.$emit("onExport");
    },
    handleRenewalsDayChange() {
      this.$emit("dayChange", this.renewalDays);
    },
  },
};
</script>